import React, { useEffect, useState } from "react";
import { authApiService } from "../../api/api";
import FilterBlock from "../../components/FilterBlock/FilterBlock";
import AddBlogModal from "../../components/modals/AddBlogModal/AddBlogModal";
import EditBlogModal from "../../components/modals/EditBlogModal/EditBlogModal";
import Pagination from "../../components/pagination/Pagination/Pagination";
import BlogsTable from "../../components/Tables/BlogsTable";
import TableTitle from "../../components/TableTitle/TableTitle";
import { IBlog } from "../../types/blogs.type";
import { usersPerPage } from "../../utils/constants/page";
import { filterBlogs } from "../../utils/filterUsers";
import styles from "./styles.module.scss";

const BlogsPage: React.FC = () => {
  const [blogs, setBlogs] = useState<IBlog[]>([]);
  const [filteredBlogs, setFilteredBlogs] = useState<IBlog[]>([]);
  const [editSelectedBlog, setEditSelectedBlog] = useState<IBlog | null>(null);
  const [visibleBlogs, setVisibleBlogs] = useState<IBlog[]>([]);
  const [activePage, setActivePage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchValue, setSearchValue] = useState("");
  const [isAddBlogModal, setIsAddBlogModal] = useState(false);
  const [isInfoModal, setInfoModal] = useState(false);

  const getBlogs = async () => {
    try {
      return await authApiService.getAllBlogs();
    } catch (err) {
      console.error(err);
    }
  };

  const changeVisibilityBlogs = (items: IBlog[]) => {
    const indexOfLast = activePage * usersPerPage;
    const indexOfFirst = indexOfLast - usersPerPage;
    setVisibleBlogs(items.slice(indexOfFirst, indexOfLast));
  };

  const getFilteredBlogs = (items: IBlog[]) => {
    setFilteredBlogs(filterBlogs(items, searchValue));
  };

  const onClickApplyModal = async () => {
    const resp = await getBlogs();
    if (resp) {
      setBlogs(resp);
      getFilteredBlogs(resp);
    }
  };

  useEffect(() => {
    setTotalPages(Math.ceil(filteredBlogs.length / usersPerPage) || 1);
  }, [filteredBlogs]);

  useEffect(() => {
    getFilteredBlogs(blogs);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValue, blogs]);

  useEffect(() => {
    (async () => {
      const data = await getBlogs();
      if (data) {
        setBlogs(data);
      }
    })();
  }, []);

  useEffect(() => {
    changeVisibilityBlogs(filteredBlogs);
    if (activePage > totalPages) {
      setActivePage(totalPages || 1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activePage, blogs, totalPages, filteredBlogs]);

  return (
    <main className={styles.container}>
      <div className={styles.header}>
        <TableTitle title="Total" count={blogs?.length || 0} />
        <div>
          <FilterBlock
            searchValue={searchValue}
            onSearchChange={setSearchValue}
            onPressAdd={() => setIsAddBlogModal(true)}
            addButtonTitle="Add blog"
          />
        </div>
      </div>

      <BlogsTable
        blogs={visibleBlogs}
        callBackInfo={setInfoModal}
        callBackEdit={setEditSelectedBlog}
      />

      <Pagination
        key={totalPages}
        count={totalPages}
        activePage={activePage}
        onClick={(page) => setActivePage(page)}
        onClickNext={() => setActivePage((prev) => prev + 1)}
        onClickPrev={() => setActivePage((prev) => prev - 1)}
      />

      {isAddBlogModal && (
        <AddBlogModal
          onClose={() => setIsAddBlogModal(false)}
          onApply={onClickApplyModal}
        />
      )}

      {editSelectedBlog && (
        <EditBlogModal
          blog={editSelectedBlog}
          onClose={() => setEditSelectedBlog(null)}
          onApply={onClickApplyModal}
          isInfo={isInfoModal}
        />
      )}
    </main>
  );
};

export default BlogsPage;
